<script>
export default {
    name: "reporting-header",
    computed: {
        translations() {
            return {
                reports: Lang.langGet('Reports'),
                visual: Lang.langGet('Visual'),
                tabular: Lang.langGet('Tabular'),
            }
        }
    }
}
</script>

<template>
    <div class="ibox-heading">
        <div class="row">
            <div class="col-md-12">
                <div class="d-flex flex-column">
                        <div class="ibox d-flex justify-space-between">
                            <div class="d-flex">
                                <h1>
                                    {{ translations.reports }}
                                </h1>
                            </div>
                            <ul class="nav nav-tabs reporting-header-container pa-1 mb-4">
                                <li class="reporting-header-tab mr-1 active">
                                    <a class="px-8" data-toggle="tab" href="#reporting-visual" aria-expanded="true">
                                        {{ translations.visual }}
                                    </a>
                                </li>
                                <li class="reporting-header-tab">
                                    <a class="px-8" data-toggle="tab" href="#reporting-list" aria-expanded="false">
                                        {{ translations.tabular }}
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
    .reporting-header-container {
        background-color: var(--color-slider-background) !important;
        border-radius: 4px;
        margin-left: 18px;
        width: fit-content;
    }
    .reporting-header-tab a {
        border-radius: 4px !important;
    }
</style>
